'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { logSentryError } from 'shared/utils/logSentry';
import { useEffect, useState } from 'react';
import { Dictionaries, getSAndyouDictionary, Locale } from 'shared/i18n/i18n-config';
import ErrorPage from 'shared/pages/CustomError';
import Header from '../../components/layout/Header';
import { useParams } from 'next/navigation';
import { defaultLocales, DefaultLocalesType } from '@/config';

type Props = {
  error: Error & { digest?: string };
};

export default function CustomErrorPage({ error }: Props) {
  let errorMessage = 'internal-server-error';
  if (error && error.message) errorMessage = error.message;

  const params = useParams<{ locale: string }>();
  const locale: Locale = (defaultLocales.includes(params.locale as DefaultLocalesType) ? params.locale : 'nl') as Locale;

  const [dictionary, setDictionary] = useState<Partial<Dictionaries> | null>(null);
  useEffect(() => {
    const getDictionary = async () => {
      try {
        setDictionary(await getSAndyouDictionary(locale));
      } catch (error) {
        console.error('cannot get dictionary:', error);
      }
    };

    getDictionary();
  }, [locale]);

  useEffect(() => {
    // Log the error to Sentry
    logSentryError(error);
  }, [error]);
  // Wrap the text in an element: browser translation replaces bare text nodes, after which
  // React can no longer remove them and the error boundary itself crashes in a loop.
  if (!dictionary) return <div>{errorMessage}</div>;

  return (
    <>
      <Header />
      <ErrorPage dictionary={dictionary} />
    </>
  );
}
